import React, { memo, useMemo } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { appTheme, useThemeColors, type ThemeColors } from '../../shared/theme';
import type { DailyMenuSection } from './dailyMenuSectionTypes';

export const SECTION_HEADER_HEIGHT = 30;

export interface DailyMenuFlowSectionHeaderProps {
  currentSection: DailyMenuSection | null;
}

function createDailyMenuFlowSectionHeaderStyles(c: ThemeColors) {
  return StyleSheet.create({
    wrap: {
      width: '100%',
      height: SECTION_HEADER_HEIGHT,
      backfaceVisibility: 'hidden',
      backgroundColor: '#fff0',
    },
    sectionHeaderTouchable: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 12,
      height: '100%',
    },
    sectionHeaderText: {
      fontSize: 14,
      fontWeight: '500',
      color: c.text,
      letterSpacing: 1,
    },
    sectionHeaderTextFull: {
      color: c.onPrimary ?? c.textInverse ?? c.white,
    },
    sectionHeaderCount: { fontSize: 14, color: c.textSecondary },
    sectionHeaderCountFull: {
      color: c.onPrimary ?? c.textInverse ?? c.white,
    },
  });
}

export const DailyMenuFlowSectionHeader = memo(({ currentSection }: DailyMenuFlowSectionHeaderProps) => {
  const colors = useThemeColors() ?? appTheme.colors;
  const styles = useMemo(() => createDailyMenuFlowSectionHeaderStyles(colors), [colors]);

  if (!currentSection) {return null;}

  const is_limit_reached = currentSection.displayLimit > 0 && currentSection.selectedQuantity >= currentSection.displayLimit;

  return (
    <View style={styles.wrap} pointerEvents="box-none">
      <View style={styles.sectionHeaderTouchable}>
        <Text style={[styles.sectionHeaderText, is_limit_reached && styles.sectionHeaderTextFull]}>{currentSection.title}</Text>
        <Text style={[styles.sectionHeaderCount, is_limit_reached && styles.sectionHeaderCountFull]}>
          {currentSection.selectedQuantity} of {currentSection.displayLimit}
        </Text>
      </View>
    </View>
  );
});
